const OFFICIAL_LOGO_URL = '/brand-assets/enw-atende-logo-oficial.png';
const OFFICIAL_THUMBNAIL_URL = '/brand-assets/enw-atende-favicon-512.png';

const LEGACY_LOGO_URLS = {
  '/brand-assets/logo.svg': OFFICIAL_LOGO_URL,
  '/brand-assets/logo_dark.svg': OFFICIAL_LOGO_URL,
  '/brand-assets/logo_thumbnail.svg': OFFICIAL_THUMBNAIL_URL,
};

// Resolve the native logo config before the first render. New asset paths avoid
// reusing the browser's long-lived cache of the previous default branding.
export const resolveBrandingAsset = url => LEGACY_LOGO_URLS[url] || url;
